import { render, staticRenderFns } from "./StudentSendMessage.vue?vue&type=template&id=4323d18b"
import script from "./StudentSendMessage.vue?vue&type=script&lang=js"
export * from "./StudentSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports